document.addEventListener('DOMContentLoaded', function () {
    const loadMoreButton = document.getElementById('load-more');
    const postsContainer = document.querySelector('.archive-post__list');

    if (loadMoreButton) {
        // Initialize excludeIds from data-exclude-ids
        let excludeIds = [];
        if (loadMoreButton.dataset.excludeIds) {
            excludeIds = [parseInt(loadMoreButton.dataset.excludeIds, 10)];
        }

        loadMoreButton.addEventListener('click', function () {
            const currentPage = parseInt(loadMoreButton.dataset.page, 10);
            const nextPage = currentPage + 1;
            const ajaxUrl = SiteVars.ajaxUrl;

            loadMoreButton.classList.add('loading');
            postsContainer.classList.add('loading');
            loadMoreButton.disabled = true;

            const formData = new URLSearchParams();
            formData.append('action', 'load_more_posts');
            formData.append('page', nextPage);
            formData.append('cat_id', loadMoreButton.dataset.catId);
            formData.append('exclude_ids', JSON.stringify(excludeIds));

            fetch(ajaxUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString()
            })
            .then(response => response.json())
            .then(data => {
                if (data.success && data.data.html) {
                    postsContainer.insertAdjacentHTML('beforeend', data.data.html);
                    loadMoreButton.dataset.page = nextPage;

                    if (!data.data.hasMore) {
                        loadMoreButton.style.display = 'none';
                    }
                } else {
                    console.error('Error loading more posts:', data);
                    loadMoreButton.style.display = 'none'; // Hide the button if no posts are found
                }
            })
            .catch(error => {
                console.error('Fetch error:', error);
            })
            .finally(() => {
                loadMoreButton.classList.remove('loading');
                postsContainer.classList.remove('loading');
                loadMoreButton.disabled = false;
            });
        });
    }
});
